exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invest-accordion svg[data-v-3695a68c]:focus{outline:none}td.exist_error[data-v-3695a68c]{border:1px solid red}.pdfFiles[data-v-3695a68c]{padding-left:0;font-size:120%;margin-top:10px;text-transform:uppercase;font-weight:700;border-bottom:none!important}.pdfFiles .show-deleted-checkbox[data-v-3695a68c]{font-size:90%!important;text-transform:lowercase;font-weight:400}.bg-disable[data-v-3695a68c]{background:#d3d3d3}", ""]);

// exports
